import { LAYOUT, MENU_BEHAVIOUR, NAV_COLOR, MENU_PLACEMENT, RADIUS, THEME_COLOR, USER_ROLE } from 'constants.js';
import {useState} from 'react';


// export const IS_DEMO = false;
export const IS_AUTH_GUARD_ACTIVE = true;
export const SERVICE_URL = '/app';
export const USE_MULTI_LANGUAGE = true;

// For detailed information: https://github.com/nfl/react-helmet#reference-guide
export const REACT_HELMET_PROPS = {
  defaultTitle: 'ATS',
  titleTemplate: '%s | ATS',
};

export const DEFAULT_PATHS = {
  APP: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  USER_WELCOME: '/dashboards/default',
  NOTFOUND: '/page-not-found',
  UNAUTHORIZED: '/unauthorized',
  INVALID_ACCESS: '/invalid-access',
  INSTRUCTIONS:'/instructions123',
  GUIDANCE:'/guidance',
};

export const DEFAULT_SETTINGS = {
  MENU_PLACEMENT: MENU_PLACEMENT.Horizontal,
  MENU_BEHAVIOUR: MENU_BEHAVIOUR.Pinned,
  LAYOUT: LAYOUT.Boxed,
  RADIUS: RADIUS.Rounded,
  COLOR: THEME_COLOR.LightBlue,
  NAV_COLOR: NAV_COLOR.Default,
  USE_SIDEBAR: false,
};


// const getUserName = (email) => {
//   if (email === "reviewer@journals.com") return "Reviewer";
//   if (email === "author@journals.com") return "Author";
//   if (email === "editor@journals.com") return "Editor";
//   return "Publisher";
// };


export const YourComponent = () => {
  const [userName, setUserName] = useState('');

  const authordata = JSON.parse(localStorage.getItem('authorpayload'));
  console.log(authordata, 'authordata');



};

export const DEFAULT_USER = {
  id: 1,
  // name: getUserName(JSON.parse(localStorage.getItem('authorpayload'))?.email),
  thumb: '/img/profile/profile-9.webp',
  role: USER_ROLE.Admin,
  email: 'lisajackson@gmail.com',
};

export const REDUX_PERSIST_KEY = 'ecommerce-platform';

export default YourComponent;
